import {customTheme} from '../theme/customTheme';
import {Customization} from '@eduvision/toolkit';

export const theme: Customization['theme'] = {
  overrideMode: 'merge',
  themeOptions: customTheme
};
